import React from 'react';
import { UniBox, type UniBoxViewPatch } from '../UniBox';
import { ordersConfig } from '../UniBox/configs';
import { ordersApi } from '../UniBox/dummyData';

type UniBoxLens = 'pipeline' | 'outreach' | 'inbox' | 'all';

interface AIWorkersTabProps {
  lens?: UniBoxLens;
  view?: 'inbox' | 'calendar' | 'kanban';
  mailbox?: 'inbox' | 'queue';
  onLensChange?: (next: UniBoxLens) => void;
  onViewChange?: (next: 'inbox' | 'calendar' | 'kanban') => void;
  onMailboxChange?: (next: 'inbox' | 'queue') => void;
  /** Batched view-state change (one URL write per action). See UniBoxViewPatch. */
  onUniBoxChange?: (patch: UniBoxViewPatch) => void;
}

const AIWorkersTab: React.FC<AIWorkersTabProps> = ({ lens, view, mailbox, onLensChange, onViewChange, onMailboxChange, onUniBoxChange }) => (
  <div className="mb-8">
    <UniBox
      config={ordersConfig}
      api={ordersApi}
      lens={lens}
      view={view}
      mailbox={mailbox}
      onLensChange={onLensChange}
      onViewChange={onViewChange}
      onMailboxChange={onMailboxChange}
      onUniBoxChange={onUniBoxChange}
    />
  </div>
);

export default AIWorkersTab;
